import { render, staticRenderFns } from "./RecordDialog.vue?vue&type=template&id=97c449ea&scoped=true&"
import script from "./RecordDialog.vue?vue&type=script&lang=js&"
export * from "./RecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c449ea",
  null
  
)

export default component.exports